import React from 'react';
import AutoCompleteField from '../../core/components/Fields/AutoCompleteField';
import { useAssistanceFieldContext } from '../pages/Assistance/AssistanceFieldContext';
import { renderContactOption } from './useLookup';
import { FieldProps, useFieldProps } from '../pages/Assistance/customizable/Field';
import { IConditionalComponent } from '../../customizations/ConditionalComponentContext';
import useForceSelectionLookupProps, { useForceSelectionReselectEventListener } from './useForceSelectionLookupProps';
import StringField from '../../core/components/Fields/StringField';
import { GROUP_SEPARATOR } from '../pages/Assistance/useDocumentConfig';

export const ContactIdField = (props: FieldProps) => {
    const { clientPartitionId, config } = useAssistanceFieldContext();
    const { lookupDefinitionId, lookupFieldName, allowInvalidIds, performLookups } = config;

    const fieldProps = useFieldProps(props);
    const { value, onValueChange, onFocus, onBlur, onCommit } = fieldProps;

    const forceSelectionLookupProps = useForceSelectionLookupProps({
        lookupType: 'ContactLookupType',
        lookupDefinitionId,
        lookupFieldName,
        partitionId: clientPartitionId,
        allowInvalidIds,
        value,
        onValueChange,
        onUpdatePayloadChange: props.onUpdatePayloadChange,
        onFocus,
        onBlur,
        onCommit,
    });

    useForceSelectionReselectEventListener(props.inputRef, forceSelectionLookupProps.onValueChange);

    // If lookups are not enabled for this field, render it as a plain StringField
    if (!performLookups || !lookupDefinitionId || !lookupFieldName) {
        return <StringField {...fieldProps} />;
    }

    return <AutoCompleteField {...fieldProps} {...forceSelectionLookupProps} renderOption={renderContactOption} />;
};

export const getContactFieldConditionalComponents = (contactFieldKey: string): IConditionalComponent[] => [
    {
        condition: ({ fieldName }) => fieldName === `${contactFieldKey}${GROUP_SEPARATOR}contact_id`,
        component: ContactIdField,
    },
    {
        condition: ({ fieldName }) => fieldName === `${contactFieldKey}${GROUP_SEPARATOR}name`,
        component: ContactIdField,
    },
];
